import { Component, Input, OnInit } from '@angular/core';
import { CitiserviMAIDsQAReport } from 'src/app/models/services/qaReport';

@Component({
  selector: 'app-report-viewer-citiservi-maids',
  templateUrl: './report-viewer-citiservi-maids.component.html',
  styleUrls: ['./report-viewer-citiservi-maids.component.sass']
})
export class ReportViewerCitiserviMaidsComponent implements OnInit {

  @Input()
  public selectedReport: CitiserviMAIDsQAReport;

  constructor() { }

  ngOnInit(): void {
  }

}
